export * from "./EventStreamMarshaller";
export * from "./Int64";
export * from "./Message";
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyx5QkFBeUIsQ0FBQztBQUN4QyxjQUFjLFNBQVMsQ0FBQztBQUN4QixjQUFjLFdBQVcsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gXCIuL0V2ZW50U3RyZWFtTWFyc2hhbGxlclwiO1xuZXhwb3J0ICogZnJvbSBcIi4vSW50NjRcIjtcbmV4cG9ydCAqIGZyb20gXCIuL01lc3NhZ2VcIjtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/predictions/node_modules/@aws-sdk/eventstream-marshaller/dist/es/index.js
// module id = null
// module chunks = 